import { FC } from 'react';

import {
    ConfirmationDialog,
    SectionMessage,
} from '@thirdspacelearning/library';

import { useDeleteProgrammeRecommendation } from '../../hooks';
import { RecommendationCopyKeys, createRecommendationCopy } from '../../copy';

type Props = {
    open: boolean;
    recommendationId: number;
    setShowDelete: (show: boolean) => void;
};

const ProgrammeRecommendationDeletion: FC<Props> = ({
    open,
    recommendationId,
    setShowDelete,
}) => {
    const { deleteRecommendation, isDeleting } =
        useDeleteProgrammeRecommendation(recommendationId, () =>
            setShowDelete(false),
        );

    return (
        <ConfirmationDialog
            open={open}
            title={createRecommendationCopy(
                RecommendationCopyKeys.DELETE_TITLE,
            )}
            confirmLabel="Delete"
            confirmButtonColor="error"
            loadingActionButton={isDeleting}
            message={
                <SectionMessage
                    type="error"
                    title={createRecommendationCopy(
                        RecommendationCopyKeys.DELETE_MESSAGE,
                    )}
                />
            }
            onConfirm={() => deleteRecommendation()}
            onClose={() => setShowDelete(false)}
            testId="delete-recommendation-dialog"
        />
    );
};

export default ProgrammeRecommendationDeletion;
